import React, { useState } from 'react';
import { Box } from '@mui/material';
import DashboardLayout from '../../../layouts/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import Subscription from './Subscription';
import AccountTabs from './AccountTabs';
import InvoicesHistory from './InvoicesHistory';
import General from './General';
import DeveloperAccounts from './DeveloperAccounts';

export default function Account() {
    const [selectedTab, setSelectedTab] = useState(0);

    return (
        <DashboardLayout
            Icon={PersonIcon}
            title="Minha conta"
        >
            <AccountTabs selectedTab={selectedTab} setSelectedTab={setSelectedTab} />

            <Box px={{ xs: 2, lg: 12 }} mt={5}>
                {selectedTab === 0 && <General />}
                {selectedTab === 1 && <DeveloperAccounts />}
                {selectedTab === 2 && <Subscription />}
                {selectedTab === 3 && <InvoicesHistory />}
            </Box>
        </DashboardLayout>
    );
}